import { Get } from "../Request";

export default {
  state: {
    NewsLetter: [],
  },
  getters: {
    GetNewsLetter(state) {
      return state.NewsLetter;
    },
  },
  actions: {
    async GetALLNewsLetter({ commit }, payload) {
      return await Get("NewsLetter/GetAllNewsLetter", payload).then((res) => {
        return commit("SetAllNewsLetter", res.data.Data);
      });
    },
  },
  mutations: {
    SetAllNewsLetter(state, payload) {
      state.NewsLetter = payload;
    },
  },
};
